import { darken, makeStyles } from '@material-ui/core/styles';
import { lighten } from '@material-ui/core';

export default makeStyles((theme) => ({
  eventContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    color: theme.palette.common.white,
    backgroundColor: theme.palette.background.event + ' !important',
    width: '100%',
    borderRadius: 5,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  coloredDot: {
    marginLeft: 2,
    marginRight: 8,
    borderRadius: 4,
    width: 0,
    height: 0,
  },
  eventTime: {
    marginRight: 8,
    color: theme.palette.common.white,
    borderRadius: 5,
    backgroundColor: theme.palette.background.event + ' !important',
  },
  eventTitleContainer: {
    display: 'flex',
    backgroundColor: theme.palette.background.event + ' !important',
    flexWrap: 'wrap',
    width: '100%',
    borderRadius: 5,
  },
  eventTitle: {
    backgroundColor: theme.palette.background.event + ' !important',
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '14.06px',
    width: '100%',
  },
  eventCapacity: {
    backgroundColor: theme.palette.background.event + ' !important',
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: 14,
    lineHeight: '16.41px',
    borderRadius: 5,
  },
  agenda: {
    '& * .fc-col-header': { marginBottom: 10 },
    '& * .fc-timegrid-event-harness': {
      borderRadius: 5,
    },
    '& td': {
      border: '0 none',
    },
    '& th': {
      border: '0 none',
    },
    '& * .fc-timegrid-slot-label-cushion': {
      color: theme.palette.primary.main,
      fontSize: 16,
      lineHeight: '18.75px',
      fontWeight: 500,
    },
    '& * .fc-scrollgrid': { border: '0 none' },
    '& * .fc-toolbar-title': {
      textTransform: 'capitalize',
      color: theme.palette.primary.main,
      paddingRight: 215,
    },
    '& * .fc-theme-standard *': {
      border: '0 none',
    },
    '& * .fc-timegrid-slot-lane': {
      border: '0 none',
      backgroundColor: theme.palette.common.white,
    },
    '& * .fc-timegrid-slot-minor': {
      border: '0 none',
      backgroundColor: theme.palette.blue.light,
    },
    '& * .fc-button': {
      backgroundColor: theme.palette.primary.main,
      border: 0,
      '&:hover': {
        opacity: 0.75,
        backgroundColor: theme.palette.primary.main,
      },
      '&:not(:disabled):active': {
        backgroundColor: darken(theme.palette.primary.main, 0.5),
      },
      '&:not(:disabled):active:focus': {
        boxShadow: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
      },
    },
    '& * .fc-next-button': {
      width: 40,
      height: 40,
    },
    '& * .fc-prev-button': {
      width: 40,
      height: 40,
    },
    '& * .fc-today-button': {
      width: 120,
      height: 40,
      fontWeight: 500,
      fontSize: 18,
      lineHeight: '21.09px',
      '&:disabled': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
      },
    },
    '& * .fc-col-header-cell': {
      textAlign: 'left',
      color: theme.palette.primary.main,
      fontSize: 16,
      fontWeight: 500,
      lineHeight: '18.75px',
    },
    '& * .fc-day': {
      border: 0,
      '& * .fc-daygrid-day-top': {
        flexDirection: 'row',
        '& a': {
          height: 25,
          width: 25,
          textAlign: 'center',
        },
      },
    },
    '& * .fc-daygrid-day:not(.fc-day-today)': {
      backgroundColor: theme.palette.blue.light,
      '& * .fc-daygrid-day-top': {
        backgroundColor: theme.palette.common.white,
      },
      '& * .fc-daygrid-day-number': {
        color: theme.palette.primary.main,
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '16.41px',
      },
    },
    '& * .fc-day-today *': {
      backgroundColor: theme.palette.blue.light,
      '& .fc-daygrid-day-top': {
        backgroundColor: theme.palette.common.white,
      },
      '& .fc-daygrid-day-number': {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        borderRadius: '100%',
        fontWeight: 500,
        fontSize: 14,
        lineHeight: '16.41px',
      },
    },
    '& * .fc-day-other:not(.fc-day-today) .fc-daygrid-day-top': {
      opacity: '1',
      '& .fc-daygrid-day-number': {
        color: lighten(theme.palette.common.black, 0.5),
      },
    },
    '& * .fc-event-main': {
      backgroundColor: theme.palette.background.event,
      borderRadius: 5,
    },
    '& * .fc-event-main-frame': {
      color: theme.palette.common.black,
      backgroundColor: theme.palette.common.white,
    },
    '& * .fc-v-event': {
      backgroundColor: theme.palette.common.white,
      border: '0 none',
      borderRadius: 5,
      boxShadow: 'none',
    },
    '& * .fc-event-time': {
      backgroundColor: theme.palette.common.white,
    },
    '& * .fc-event': {
      '&:hover': {
        background: 'none',
      },
      '&:focus': {
        boxShadow: 'none',
        '&:after ': {
          opacity: 0,
        },
      },
    },
    '& * .fc-event-title': {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.common.black,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '14.06px',
    },
    '& * .fc-event-title-container': {
      backgroundColor: theme.palette.common.white,
    },
  },
}));
